import { useCurrency } from 'hooks/useCurrency';
import { addCommasToNumber } from 'utils/utils';

const WalletHistoryPrice = ({ price }) => {
    const convertedPrice = useCurrency(price);
    return `${convertedPrice?.symbol} ${addCommasToNumber(convertedPrice?.price || '0')}`;
};

export default WalletHistoryPrice;
